import { always } from 'rambda'
import { factory } from '@store/utils'

export const SECTION_POSITION_EXPORT = {
  DEFAULT: 'DEFAULT',
  END: 'END',
}

export default {
  auto: '*',

  store: {
    getters: {
      sectionFactory: factory(({ authUser }) => ({
        articleId: null,
        siteId: null,
        userId: authUser.id,
        position: 1,
        positionExport: SECTION_POSITION_EXPORT.DEFAULT,
        questions: [],
        textVariantIndex: 0,
        textVariants: [''],
        links: [],
        images: [],
        imagesPhrases: [],
        fields: {},
        // doUseTemplatePoints: true,
      })),

      positionExportOptions: always([
        {
          label: 'Default',
          value: SECTION_POSITION_EXPORT.DEFAULT,
        },
        {
          label: 'End',
          value: SECTION_POSITION_EXPORT.END,
        },
      ]),
    },
  },
}
